"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClockType;
(function (ClockType) {
    ClockType["HOURS"] = "hours";
    ClockType["MINUTES"] = "minutes";
    ClockType["SECONDS"] = "seconds";
})(ClockType || (ClockType = {}));
exports.default = ClockType;
